import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API = "https://sl-back-sigma.vercel.app/payment";

// CREATE CHECKOUT SESSION
export const createCheckoutSession = createAsyncThunk(
  "payment/createCheckoutSession",
  async (data, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.post(
        `${API}/create-checkout-session`, 
        data,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      return res.data; // { id }
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  },
);

// GET USER PAYMENTS
export const getMyPayments = createAsyncThunk(
  "payment/getMyPayments",
  async (token, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${API}/my-payments`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return res.data.orders;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  },
);

const paymentSlice = createSlice({
  name: "payment",
  initialState: {
    loading: false,
    sessionId: null,
    payments: [],
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createCheckoutSession.pending, (state) => {
        state.loading = true;
      })
      .addCase(createCheckoutSession.fulfilled, (state, action) => {
        state.loading = false;
        state.sessionId = action.payload.id;
      })
      .addCase(createCheckoutSession.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getMyPayments.fulfilled, (state, action) => {
        state.payments = action.payload;
      });
  },
});

export default paymentSlice.reducer;
